module.exports = __webpack_public_path__ + "static/img/wsg_big.205095f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutus/wsg_big.png
// module id = BRfB
// module chunks = 18